export default __webpack_public_path__ + "static/wappen-97d089b6346c155bf850893649fae287.png";